/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusObjektAnforderungSearchResultDto } from '../../models/lexplus-objekt-anforderung-search-result-dto';

export interface ObjekteControllerSearchAnforderungenV1$Params {
  id: number;
  search?: string;
  limit?: number;
}

export function objekteControllerSearchAnforderungenV1(http: HttpClient, rootUrl: string, params: ObjekteControllerSearchAnforderungenV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusObjektAnforderungSearchResultDto>>> {
  const rb = new RequestBuilder(rootUrl, objekteControllerSearchAnforderungenV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('search', params.search, {});
    rb.query('limit', params.limit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusObjektAnforderungSearchResultDto>>;
    })
  );
}

objekteControllerSearchAnforderungenV1.PATH = '/v1/objekte/{id}/anforderungen/search';
